
export const SET_CUR_PANELID = 'setCurPanelId';
export const SET_PROJETLID = 'setProjectId';
export const SET_GRID = 'setGrid';
export const SET_PANELDATA_CG = 'setPanelData_cg';
export const SET_ECHARTS_RESIZE_KEY = 'setEchartResizeKey';
export const SET_CURPANEL_STATUS = 'setCurPanelStatus';
export const SET_CURPROJECT_STATUS = 'setCurProjetStatus';
export const SET_CAN_STATUS = 'setCanStatus';
export const DELETE_DATASOURCE = 'deleteDataSource';
export const SET_TREE_CONFIG_DATA = 'setTreeConfigData';



// WEBPACK FOOTER //
// ./src/store/modules/engineering/mutations-types.js